import React, { useEffect, useState } from "react";
import editIcon from "../../../resources/images/pencile.svg";
import deleteIcon from "../../../resources/images/delete.svg";
import globeIcon from "../../../resources/images/globe.svg"
import multiUserIcon from "../../../resources/images/multipleUsers.svg"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ApplicantActions } from '../../../actions/applicant.actions';
import { useDispatch, useSelector } from 'react-redux';






function DropdownMenuComponent(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.authentication.user.userRole);



  useEffect(() => {
    if (props?.row?.id === props.editSelComment) {
      props.setEditedInput(props.row.message);
      props.setEditUploadedFilepath([])
      props.setEditUploadedFiles([]);
      props.setUploadedFilepath([]);
      props.setUploadedFiles([]);
      props.setMessageInput("");
      props.setEditEditorState(props.htmlToDraftBlocks(props.row.message));
    }
  }, [props.editSelComment]);

  const deleteClick = () => {
    if (props?.row?.id) {
      props.setDeleteId(props?.row?.id);
    }
  };

  const editClick = () => {
    if (props?.row?.id) {
      props.setEditSelComment(props?.row?.id);
    }
  };

  const updateCommentAccess = () => {
    const req = {
      id: props.row.id,
      isPrivate: !props?.row?.isPrivate,
      selectedId: props?.selectedId
    };
    if (props?.row?.id) {
      dispatch(ApplicantActions.updateCommentAccess(req)); 
    }
  };

  return (
    <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className={props?.className}
    >
      <DropdownToggle caret size="sm">
        <span className="threedots" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => editClick()}>
          {" "}
          <img src={editIcon} className="drop-icon" /> Edit
        </DropdownItem>
        <DropdownItem onClick={() => deleteClick()}>
          <img src={deleteIcon} className="drop-icon" /> Delete
        </DropdownItem>
        {!props.announcementTab && userRole !== 4 && 
          <DropdownItem onClick={() => updateCommentAccess()}>
            {props?.row?.isPrivate ? 
              <img width={12} src={globeIcon} className="drop-icon" />  
              :  <img width={12} src={multiUserIcon} className="drop-icon" /> 
            } 
            {props?.row?.isPrivate ? "Visibility All" : "Visibility Limited" }
          </DropdownItem>
        }
        
      </DropdownMenu>
    </Dropdown> 
  );
}
export default DropdownMenuComponent;
